module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_h('div', {
    staticClass: "nav nav-pills"
  }, [_h('li', {
    staticClass: "nav-item"
  }, [_h('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, ["Inicio"])]), " ", _h('li', {
    staticClass: "nav-item"
  }, [_h('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/blog"
    }
  }, ["Blog"])]), " ", _h('li', {
    staticClass: "nav-item"
  }, [_h('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/suscripciones"
    }
  }, ["Suscripciones"])]), " ", _h('li', {
    staticClass: "nav-item"
  }, [_h('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/registros"
    }
  }, ["Registros"])])]), " ", _h('router-view')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55fd0abf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 201
// module chunks = 2